import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL;
const InventoryService = {
  async getHistory(name_materiel,code_immo,state,direction) {
    try {
      const result = await axios.get(`${apiUrl}/HistoryInventory/`,{params: {name_materiel:name_materiel,code_immo:code_immo,state:state,direction:direction}});
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getMaterielStatus(name_materiel,code_immo,state,direction,mes_materiels) {
    try {
      const result = await axios.get(`${apiUrl}/HistoryInventory/materielStatus`,{params: 
        {name_materiel:name_materiel,code_immo:code_immo,state:state,direction:direction,mes_materiels:mes_materiels}});
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getHistoryTransfered(name_materiel,code_immo,state) {
    try {
      const result = await axios.get(`${apiUrl}/HistoryInventory/transfered`,{params: {name_materiel:name_materiel,code_immo:code_immo,state:state}});
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getEtatValue(date1,date2) {
    try {
      const result = await axios.get(`${apiUrl}/HistoryInventory/statisticState/`,{params: {date1 : date1, date2 : date2}});
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getHistoryByCode(id) {
    try {
      const result = await axios.get(
        `${apiUrl}/HistoryInventory/codeImmo/${id}`
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async logistics_manager() {
    try {
      const result = await axios.get(
        `${apiUrl}/HistoryInventory/respLogistic`
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async exportExcel(direction) {
    try {
      const result = await axios.get(`${apiUrl}/HistoryInventory/export/${direction}`);
      if (result) {
        // TODO: replace result.data.message by the token
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async exportDetenteurExcel(direction) {
    try {
      const result = await axios.get(`${apiUrl}/HistoryInventory/exportDetenteur/${direction}`);
      if (result) {
        // TODO: replace result.data.message by the token
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getHistoryImmo(data) {
    try {
      const result = await axios.post(`${apiUrl}/HistoryInventory/codeImmos`, {
        data:data
    });
      if (result) {
        // TODO: replace result.data.message by the token
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async validateImmoToStock(data) {
    try {
      const result = await axios.post(`${apiUrl}/HistoryInventory/addImmoToStock`, {
        data:data
    });
      if (result) {
        // TODO: replace result.data.message by the token
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async validateImmoNewAffectation(data,user_id) {
    try {
      const result = await axios.post(`${apiUrl}/HistoryInventory/addNewAffectation`, {
        data:data,
        id:user_id
    });
      if (result) {
        // TODO: replace result.data.message by the token
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
   async validateInventory(data,user_id) {
    try {
      const result = await axios.post(`${apiUrl}/HistoryInventory/inventorystate`, {
        data:data,
        id:user_id
    });
      if (result) {
        // TODO: replace result.data.message by the token
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async validateImmoNewTransfert(data,direction_id,recepteur_id) {
    try {
      const result = await axios.post(`${apiUrl}/HistoryInventory/addNewATransfert`, {
        data:data,
        id:direction_id,
        id_recepteur:recepteur_id
    });
      if (result) {
        // TODO: replace result.data.message by the token
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async validateStateByOldHolder(user_id,data,list_immo) {
    try {
      const result = await axios.post(`${apiUrl}/HistoryInventory/validateStateByOldHolder`, {
        id:user_id,
        data:data,
        list_immo:list_immo
    });
      if (result) {
        // TODO: replace result.data.message by the token
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async validateStateAffectationHolder(user_id,data,list_immo) {
    try {
      const result = await axios.post(`${apiUrl}/HistoryInventory/validateStateAffectationHolder`, {
        id:user_id,
        data:data,
        list_immo:list_immo
    });
      if (result) {
        // TODO: replace result.data.message by the token
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async validateStateStockHolder(user_id,data,list_immo) {
    try {
      const result = await axios.post(`${apiUrl}/HistoryInventory/validateStateStockHolder`, {
        id:user_id,
        data:data,
        list_immo:list_immo
    });
      if (result) {
        // TODO: replace result.data.message by the token
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async validateStateAffectationLogisticsManager(data) {
    try {
      const result = await axios.post(`${apiUrl}/HistoryInventory/validateStateAffectationLogisticsManager`, {
        data:data
    });
      if (result) {
        // TODO: replace result.data.message by the token
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async validateStateTransfert(data) {
    try {
      const result = await axios.post(`${apiUrl}/HistoryInventory/validateStateTransfert`, {
        data:data
    });
      if (result) {
        // TODO: replace result.data.message by the token
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async validateImmoAffectationSheet(user_id,data) {
    try {
      const result = await axios.post(`${apiUrl}/HistoryInventory/validateImmoAffectationSheet`, {
        id:user_id,
        data:data
    });
      if (result) {
        // TODO: replace result.data.message by the token
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getMineImmoHistory() {
    try {
      const result = await axios.get(`${apiUrl}/HistoryInventory/Mine`);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getCountMineImmoHistory() {
    try {
      const result = await axios.get(`${apiUrl}/HistoryInventory/mineCount`);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getMinePendingImmoHistory(name_materiel,code_immo,state,dates2,status1,status2) {
    try {
      const result = await axios.get(`${apiUrl}/HistoryInventory/PendingValidation`,{params: {name_materiel:name_materiel,code_immo:code_immo,state:state,dates2:dates2,status1:status1,status2:status2}});
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getImmoHistoryByDetention(person_id) {
    try {
      const result = await axios.get(`${apiUrl}/HistoryInventory/ImmoHistoryByDetention/${person_id}`);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getCountMinePendingImmoHistory() {
    try {
      const result = await axios.get(`${apiUrl}/HistoryInventory/countPendingValidationByUser`);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async generateSignedPDf(id) {
    try {
      const result = await axios.get(`${apiUrl}/HistoryInventory/generateSignedPDf/${id}`, {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/pdf',
        }});
      if (result) {
        // TODO: replace result.data.message by the token
        return result;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async generateAffectationSheetPDf(id) {
    try {
      const result = await axios.get(`${apiUrl}/HistoryInventory/generateAffectationSheetPDf/${id}`, {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/pdf',
        }});
      if (result) {
        // TODO: replace result.data.message by the token
        return result;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async downloadAffectationSheetByUserPDf(person_id) {
    try {
        const result = await axios.get(
            `${apiUrl}/HistoryInventory/downloadAffectationSheetByUserPDf/${person_id}`,
            {
                responseType: 'blob',
                headers: {
                    'Accept': 'application/pdf, application/json'
                }
            }
        );
        
        if (result.headers['content-type']?.includes('application/json')) {
            const text = await result.data.text();
            const errorData = JSON.parse(text);
            throw { response: { status: result.status, data: errorData } };
        }
        
        return result;
        
    } catch (error) {
        const errorResponse = {
            response: {
                status: error.response?.status || 500,
                data: error.response?.data || {
                    status: false,
                    message: 'Erreur de téléchargement'
                }
            }
        };
        
        if (error.response?.data && typeof error.response.data === 'string') {
            try {
                errorResponse.response.data = JSON.parse(error.response.data);
            } catch (e) {
                // Garder l'erreur brute
            }
        }
        
        throw errorResponse;
    }
  }
};
export default InventoryService;
